import bannerBg from '../../../assets/images/learning-progress-banner-bg.png';
import bannerDecor from '../../../assets/images/learning-progress-banner-decor.png';
import bannerIllustration from '../../../assets/images/learning-progress-banner-illustration.png';

export default function ProgressBanner({ userName }) {
  const firstName = userName?.trim().split(' ')[0] || 'Student';

  return (
    <section className="relative my-10 h-[218px] w-full max-w-[804px] overflow-hidden rounded-[24px]">
      <img
        src={bannerBg}
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover"
      />

      <img
        src={bannerDecor}
        alt=""
        aria-hidden
        className="pointer-events-none absolute bottom-0 right-0 z-[1] h-[72px] w-auto sm:w-[203px] object-contain sm:h-[109px]"
      />

      <div className="relative z-10 flex h-full flex-col items-center sm:flex-row">
        <img
          src={bannerIllustration}
          alt=""
          aria-hidden
          className="h-[218px] w-[240px] shrink-0 object-contain"
        />

        <div className="max-w-xl px-4 text-center sm:px-0 sm:text-left">
          <p className="text-base font-normal text-[#1A1A1A]">Hi, {firstName}</p>
          <h1 className="mt-1 text-2xl font-semibold leading-tight text-[#1A1A1A] sm:text-[32px]">
            Here, is your Learning Progress
          </h1>
          <p className="mt-1 text-right text-sm font-medium leading-relaxed text-[#666666] sm:text-[14px]">
            Track your study progress, performance &amp; improvement
          </p>
        </div>
      </div>
    </section>
  );
}
